// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"c3a71a48","9296":"b3fa0c66","9559":"66b504a4"}[chunkId] + ".chunk.css";
};